import axios from 'axios';

const state = () => ({
	testScore: null, // This attempt test score
});

const getters = {
	testScore: (state) => state.testScore,
};
const mutations = {
	setTestScore(state, testScore) {
		state.testScore = testScore;
	},
	clearStore(state) {
		state.testScore = null;
	},
};

const actions = {
	async fetchTestScoreById(store, { testScoreId }) {
		const res = await axios.get('/api/testScores/' + testScoreId);
		return res.data.testScore;
	},
	async fetchTestScores(store, { testId, userId, projectFields }) {
		const res = await axios.post('/api/testScores/search', { testId, userId, projectFields });
		return res.data.testScores;
	},
	async createTestScore(store, { testId, userId, testBankId, attempt }) {
		const res = await axios.post('/api/testScores/create', { testId, userId, testBankId, attempt });
		store.commit('setTestScore', res.data.testScore);
		return res.data.testScore;
	},
	async createPositionTestScore(store, { testId, userId, testBankId, attempt }) {
		const res = await axios.post('/api/testScores/create', { testId, userId, testBankId, attempt });
		await axios.post('/api/candidate-in-test/create-for-position-test', { testId, userId });
		store.commit('setTestScore', res.data.testScore);
		return res.data.testScore;
	},
	/**
	 * Sends only the most recently added answer and duration entry to the API
	 * instead of the full growing arrays (Fix 4 payload reduction). The backend
	 * uses the isDelta flag to distinguish this from legacy full-array requests
	 * sent by cached clients on the previous build, preserving backward
	 * compatibility. The Vuex store is still updated with the full client-side
	 * object so local state stays accurate.
	 *
	 * @changed_at 29/04/2026 by AI (claude-sonnet-4-5)
	 */
	async updateTestScore(store, { toUpdateTestScore }) {
		const userAnswers = toUpdateTestScore.user_answers;
		const durationPerTrack = toUpdateTestScore.duration_per_track;
		const newAnswer = userAnswers[userAnswers.length - 1];
		const newDuration = durationPerTrack[durationPerTrack.length - 1];

		await axios.put('/api/testScores/' + toUpdateTestScore._id, {
			status: toUpdateTestScore.status,
			score: toUpdateTestScore.score,
			isDelta: true,
			newAnswer,
			newDuration,
		});
		store.commit('setTestScore', toUpdateTestScore);
	},
	async addTestCheating(store, { testScoreId, testTrackId, type }) {
		await axios.post(`/api/testScores/${testScoreId}/cheating/add`, {
			testTrackId,
			type,
		});
	},
	clear(store) {
		store.commit('clearStore');
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
